import { useQuery } from '@tanstack/react-query';
import { Event } from '../../../types/Event';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const fetchEvent = async (uuid: string, template?: string, parent?: string) => {
  const config = template ? { params: { template, parent } } : {};
  const response = await CustomAxios.get<Event>(`events/${uuid}`, config);
  const { data } = response;
  return data;
};

interface UseGetEventByIdProps {
  uuid: string;
  template?: string;
  parent?: string;
}
export function useGetEventById({ uuid, template, parent }: UseGetEventByIdProps) {
  const query = useQuery({
    queryKey: [queryKeys.allEvents, uuid],
    queryFn: () => fetchEvent(uuid, template, parent),
  });

  return query;
}
